import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbItem } from '../../shared/components/breadcrumb/breadcrumb.component';
import { ApplicationSimplifyService } from '../application-simplify.service';
import { SpinnerServiceService } from '../../shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-candidature-simplify',
  templateUrl: './candidature-simplify.component.html',
  styleUrls: ['./candidature-simplify.component.css']
})
export class CandidatureSimplifyComponent implements OnInit {
  form!: FormGroup;

  certificatDynamicOption: any[] = [];
  selectedCertificates: number[] = [];
  selectedCohorte: any;
  cohorteOption: any[] = [];
  isEditMode: boolean = false;
  applicationId: number | null = null;
  showConfirmModal = false;
  successMessage: string | null = null;
  isClosing = false;
  errorMessage: string | null = null;
  constructor(
    private formBuilder: FormBuilder,
    private service: ApplicationSimplifyService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: SpinnerServiceService

  ) {
    this.form = this.formBuilder.group({
      applicationName: ['', Validators.required],
      applicationType: ['', Validators.required],
      applicationInformations: [''],
      openDate: [null, Validators.required],
      closeDate: [null, Validators.required],
      cohorte: [null, Validators.required],
      param: [null, Validators.required],
      certificatChoiceList: this.formBuilder.array([]),
    });
  }

  get certificatsList() {
    return this.form.get('certificatsList') as FormArray;
  }

  get certificatChoiceList() {
    return this.form.get('certificatChoiceList') as FormArray;
  }

 ngOnInit(): void {
   
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.isEditMode = true;
      this.applicationId = +idParam;
    }
    
    this.getlistWebinaireCohorte();
  }
getlistWebinaireCohorte() {
    this.service.getGroupedWebinars().subscribe({
      next: (response) => {
        this.cohorteOption = response;
        
        if (this.isEditMode && this.applicationId) {
          this.loadApplicationForEdit(this.applicationId);
        }
      },
      error: (error) => {
        console.error('Erreur chargement cohortes:', error);
      }
    });
  }
  etlistWebinaireCohorte() {
    this.service.getGroupedWebinars().subscribe({
      next: (response) => {
        this.cohorteOption = response;
       
        if (this.isEditMode && this.applicationId) {
          this.loadApplicationForEdit(this.applicationId);
        }
      },
      error: (error) => {
        console.error('Erreur chargement cohortes:', error);
      }
    });
  }

loadApplicationForEdit(id: number): void {
    this.spinner.showSpinner();
    this.service.getApplicationWebinaireById(id).subscribe({
      next: (app: any) => {

        // Format date "yyyy-MM-dd" pour input type="date"
        const formatDate = (d: any): string | null => {
          if (!d) return null;
          const str = typeof d === 'string' ? d : new Date(d).toISOString();
          return str.substring(0, 10);
        };

        // Trouver l'objet cohorte exact dans cohorteOption
        // cohorteOption = [{cohorte: "MAE...", list: [...]}, ...]
        const matchedGroup = this.cohorteOption.find(
          (item: any) => item.cohorte === app.cohorte
        );

        if (matchedGroup) {
          this.selectedCohorte = matchedGroup;
          this.certificatDynamicOption = matchedGroup.list ?? [];
        }

        
        this.form.patchValue({
          applicationName: app.applicationName,
          applicationType: app.applicationType ?? 'WEBINAIRE',
          applicationInformations: app.applicationInformations,
          openDate: formatDate(app.openDate),
          closeDate: formatDate(app.closeDate),
          cohorte: matchedGroup ?? null,
          param: app.params, 
        });
        this.form.get('openDate')?.disable();
        
        this.selectedCertificates = (app.webinars ?? [])
          .map((w: any) => w.id)
          .filter((v: any) => v != null);

        this.updateSelectedCertificatesInForm();
        this.spinner.hideSpinner();
      },
      error: (error) => {
        console.error('Erreur chargement appel à modifier:', error);
        this.spinner.hideSpinner();
      },
    });
  }


  isFieldInvalid(controlName: string): boolean | null {
    const controle = this.form.get(controlName);
    return controle && controle.invalid && controle.touched;
  }

  onCohorteChange() {
    const selectedGroup = this.form.get('cohorte')?.value;
    if (selectedGroup && selectedGroup.list) {
      this.selectedCohorte = selectedGroup;
      this.certificatDynamicOption = selectedGroup.list;
      
      this.selectedCertificates = [];
      this.updateSelectedCertificatesInForm();
    } else {
      this.certificatDynamicOption = [];
    }
  }

  onCheckboxChange(event: Event, certificatId: number) {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      if (!this.selectedCertificates.includes(certificatId)) {
        this.selectedCertificates = [
          ...this.selectedCertificates,
          certificatId,
        ];
      }
    } else {
      this.selectedCertificates = this.selectedCertificates.filter(
        (id) => id !== certificatId
      );
    }

    // console.log('Certificats sélectionnés :', this.selectedCertificates);
    this.updateSelectedCertificatesInForm();
  }

  updateSelectedCertificatesInForm() {
    const certificatChoiceList = this.certificatChoiceList;
    certificatChoiceList.clear();

    this.selectedCertificates.forEach((certificatId) => {
      certificatChoiceList.push(this.formBuilder.control(certificatId));
    });
  }

openConfirmModal() {
  if (this.form.valid) {
    this.showConfirmModal = true;
  } else {
    this.form.markAllAsTouched();
  }
}

cancelSubmit() {
  this.showConfirmModal = false;
}

confirmSubmit() {
  this.showConfirmModal = false;
  if (!this.form.valid) {
    this.form.markAllAsTouched();
    return;
  }

  this.spinner.showSpinner();
  const formValue = this.form.getRawValue(); 
  const requestBody = {
    applicationName: formValue.applicationName,
    applicationType: formValue.applicationType,
    applicationInformations: formValue.applicationInformations,
    openDate: formValue.openDate,
    closeDate: formValue.closeDate,
    cohorte: this.selectedCohorte.cohorte,
    webinarSimplifyList: formValue.certificatChoiceList,
    param: formValue.param
  };

  if (this.isEditMode && this.applicationId) {
    this.service.updateApplicationWebinaire(this.applicationId, requestBody).subscribe({
      next: () => {
      this.spinner.hideSpinner();
      this.successMessage = "L'appel webinaire a été modifié avec succès.";
      setTimeout(() => {
        this.isClosing = true;
      }, 2300); // démarre le fondu 500ms avant la redirection
      setTimeout(() => {
        this.router.navigate(['dashboard', 'appels', 'listAppels'], {
  queryParams: { type: 'webinaire' },
});
      }, 2800);
      },
      error: (error: any) => {
        console.error("Erreur lors de la modification de l'appel :", error);
        this.errorMessage = "Une erreur est survenue lors de la modification de l'appel. Veuillez réessayer.";
        setTimeout(() => {
          this.errorMessage = null;
        }, 3000);
      },
    });
  } else {
    this.service.addCandidature(requestBody).subscribe({
     next: () => {
          this.spinner.hideSpinner();
          this.successMessage = "L'appel webinaire a été créé avec succès.";
          setTimeout(() => {
            this.isClosing = true;
          }, 2300); // démarre le fondu 500ms avant la redirection
          setTimeout(() => {
            this.router.navigate(['dashboard', 'appels', 'listAppels'], {
  queryParams: { type: 'webinaire' },
});
          }, 2800);
        },
              error: (error: any) => {
          console.error("Erreur lors de la création de l'appel :", error);
          this.errorMessage = "Une erreur est survenue lors de la création de l'appel. Veuillez réessayer.";
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        },
    });
  }
}

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    { label: 'GESTION DES APPELS', url: '/dashboard/appels/listAppels' },
    {
      label: 'APPEL À CANDIDATURES WEBINAIRE'
    },
  ];

}
